import { Condiciones } from './../../../models/condiciones.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-condiciones",
    templateUrl: "./condiciones.component.html",
    styleUrls: ["./condiciones.component.css"],
    providers: [FormService]
})

export class CondicionesComponent {
      public rows = [];
      public actualRow;
      public condiciones: Condiciones;
      public form;
      public matcher = new FormService();

      constructor(){
        this.form = new FormGroup({
            condicion1: new FormControl('', Validators.required),
            condicion2: new FormControl('', Validators.required),
            condicion3: new FormControl('', Validators.required),
            condicion4: new FormControl('', Validators.required), 
            condicion5: new FormControl('', Validators.required), 
            condicion6: new FormControl('', Validators.required), 
            condicion7: new FormControl('', Validators.required)
                 
        })
        if(!JSON.parse(localStorage.getItem("condiciones"))){
            localStorage.setItem("condiciones", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("condiciones"));
            this.form.controls['condicion1'].setValue(this.rows[0]?this.rows[0].condicion1:false);
            this.form.controls['condicion2'].setValue(this.rows[0]?this.rows[0].condicion2:false);
            this.form.controls['condicion3'].setValue(this.rows[0]?this.rows[0].condicion3:false);
            this.form.controls['condicion4'].setValue(this.rows[0]?this.rows[0].condicion4:false);
            this.form.controls['condicion5'].setValue(this.rows[0]?this.rows[0].condicion5:false);
            this.form.controls['condicion6'].setValue(this.rows[0]?this.rows[0].condicion6:false);
            this.form.controls['condicion7'].setValue(this.rows[0]?this.rows[0].condicion7:false);
           
        }
        this.condiciones = {condicion1:'',condicion2:'',condicion3:'',condicion4:'',condicion5:'',condicion6:'',condicion7:''};
    }

    add_condiciones(){
        localStorage.setItem("condiciones",JSON.stringify([]));
        this.actualRow = localStorage.getItem("condiciones");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            condicion1: this.form.value.condicion1,
            condicion2: this.form.value.condicion2,
            condicion3: this.form.value.condicion3,
            condicion4: this.form.value.condicion4,
            condicion5: this.form.value.condicion5,
            condicion6: this.form.value.condicion6,
            condicion7: this.form.value.condicion7
        })
        localStorage.setItem("condiciones", JSON.stringify(this.rows));
    }

    delete_condiciones(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("condiciones", JSON.stringify(this.rows));
            }
        }
    }

}